import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// English translations
import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enFiles from './locales/en/files.json';
import enClients from './locales/en/clients.json';
import enDiagnostics from './locales/en/diagnostics.json';
import enSharedLinks from './locales/en/sharedLinks.json';
import enNotifications from './locales/en/notifications.json';
import enPublic from './locales/en/public.json';
import enDocuments from './locales/en/documents.json';
import enAdmin from './locales/en/admin.json';

// Spanish translations
import esCommon from './locales/es/common.json';
import esAuth from './locales/es/auth.json';
import esFiles from './locales/es/files.json';
import esClients from './locales/es/clients.json';
import esDiagnostics from './locales/es/diagnostics.json';
import esSharedLinks from './locales/es/sharedLinks.json';
import esNotifications from './locales/es/notifications.json';
import esPublic from './locales/es/public.json';
import esDocuments from './locales/es/documents.json';
import esAdmin from './locales/es/admin.json';

const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    files: enFiles,
    clients: enClients,
    diagnostics: enDiagnostics,
    sharedLinks: enSharedLinks,
    notifications: enNotifications,
    public: enPublic,
    documents: enDocuments,
    admin: enAdmin,
  },
  es: {
    common: esCommon,
    auth: esAuth,
    files: esFiles,
    clients: esClients,
    diagnostics: esDiagnostics,
    sharedLinks: esSharedLinks,
    notifications: esNotifications,
    public: esPublic,
    documents: esDocuments,
    admin: esAdmin,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'auth', 'files', 'clients', 'diagnostics', 'sharedLinks', 'notifications', 'public', 'documents', 'admin'],

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'affogato-language',
    },

    interpolation: {
      escapeValue: false, // React already escapes
    },

    react: {
      useSuspense: false,
    },
  });

// Export for non-React usage (stores, API client)
export const t = i18n.t.bind(i18n);
export default i18n;
